import { Box, Text } from '@bonusly/design-system';

export const MemoriesSection = () => {
	return (
		<Box>
			<Text fontSize="sm" fontWeight="semibold" color="text.default" mb={2}>
				Memories
			</Text>
			<Text fontSize="sm" color="text.softer">
				Coming soon
			</Text>
		</Box>
	);
};
